import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {useStore} from "hooks/useStore";
import {useFetch} from "hooks/useFetch";

const CreditModeFilter = ({
    value,
    onChange,
    disabled = false,
    showAllOption = true,
    allowClear = true,
    hideTitle = false,
    marginBottom = "20px",
    ...props
}) => {
    const {t} = useTranslation([]);
    const stores = useStore();

    const [, creditModeOptions] = useFetch({
        fetchFn: stores.companyStore.creditModeFilters.bind(null),
        initialCall: true
    });

    return (
        <React.Fragment>
            {!hideTitle && <h5>Kredi Modu</h5>}
            <SelectField
                data-testid="creditModeSelect"
                value={value}
                onChange={onChange}
                disabled={disabled}
                allowClear={allowClear}
                mb={marginBottom}
                {...props}
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="creditModeSelect_option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {creditModeOptions?.map(creditMode => (
                    <SelectField.Option
                        key={creditMode?.value}
                        value={creditMode?.value}
                        data-testid="creditModeSelect_option"
                    >
                        {creditMode?.label || "-"}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default CreditModeFilter;
